import { render } from "./ChatBell.vue?vue&type=template&id=0c6a137c&scoped=true"
import script from "./ChatBell.vue?vue&type=script&lang=js"
export * from "./ChatBell.vue?vue&type=script&lang=js"

import "./ChatBell.vue?vue&type=style&index=0&id=0c6a137c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6a137c"]])

export default __exports__